import { createQueryClient } from "@jkast90/kast-common/query-client";
import { statusOf } from "@jkast90/kast-common/api-client";

// No subscribeToAuthErrors: the app has no 401 signal of its own. A query's
// 401 clears the cache, and so does the account changing (CacheScope). The
// client's errors are ApiErrors, so statusOf reads their status directly.
export const queryClient = createQueryClient({ statusOf });
